<template>
  <div>
    <div class="content">
      <life-search-bar class="search" :value="$route.params.search" />
      <mu-content-block v-if="isLoading" style="text-align: center">
        <mu-circular-progress :size="32"></mu-circular-progress>
        <br/>
        <span v-text="$t('message.loadingText')"></span>
      </mu-content-block>
      <div class="title-block" v-if="!isLoading">
        <div class="title">
          <h2>Search results for "{{$route.params.search}}"</h2>
        </div>
        <div class="sortBy">
          <font-awesome-icon icon="chevron-down"></font-awesome-icon>
          <mu-select-field
            v-model="sortBy"
            :underlineShow="false"
            v-on:change="filterResults"
          >
            <mu-menu-item class="sortByItems" :value="1" title="Most favourites" />
            <mu-menu-item class="sortByItems" :value="2" title="Newest first" />
          </mu-select-field>
        </div>
      </div>
      <div id="lifeSearchArticles" v-if="!isLoading">
        <mu-flexbox class="row" :gutter="16" v-for="chunks, index in chunkedItems" :key="'chunk-' + index" align="flex-start" style="margin-top: 20px;margin-bottom: 20px;">
          <mu-flexbox-item class="post" v-for="post, index in chunks" :key="'post-' + index">
            <div class="search-card">
              <router-link :to="{ name: 'LifeStyleArticle', params: { permalink: post.post_slug }}">
                <figure class="img">
                  <img :src="post.post_image" />
                </figure>
                <h4 v-text="post.post_title"></h4>
                <div class="info">
                  <div class="date">
                    <mu-icon value="watch_later" color="#5b617c" />
                    <time datetime="post.post_date" v-text="moment(post.post_date).fromNow()"></time>
                  </div>
                  <div class="favourites">
                    <mu-icon value="favorite" color="#d83e38" />
                    <span v-text="post.post_favourites"></span>
                  </div>
                </div>
              </router-link>
            </div>
          </mu-flexbox-item>
        </mu-flexbox>
        <p v-if="!chunkedItems.length">Sorry, could not not find any articles based on your search</p>
        <mu-content-block align="center" v-if="loadingMore">
          <mu-circular-progress :size="32"></mu-circular-progress>
        </mu-content-block>
        <div class="pagination">
          <mu-flat-button v-if="loadMore" class="load-more" label="Load more" @click.prevent="updateResults()" />
        </div>
      </div>
      <mu-content-block align="center" v-if="!isLoading && isAppending">
        <mu-circular-progress :size="32"></mu-circular-progress>
      </mu-content-block>
    </div>
  </div>
</template>

<script>

  import TitleManager from '../../../helpers/TitleManager'
  import LifeStyleApi from '../../../api/LifeStyle/index';

  import LifeSearchBar from "../../../components/LifeStyle/LifeSearchBar/LifeSearchBar";

  export default {
    components: {LifeSearchBar},
    watch: {
      "$route": function() {
        let self = this;
        self.initMounted();
      }
    },
    data () {
      return {
        posts: [],
        getPostParams: {
          page: 1,
          per_page: 9,
          size: 'large',
        },
        total_pages: '',
        isLoading: true,
        isPostsFinished: false,
        isAppending: false,
        sortBy: 1,
        loadingMore: false,
        loadMore: true,
      }
    },
    methods: {
      updateResults() {
        let self = this;
        self.getPostParams.page++;
        self.loadingMore = true;
        let searchValue = self.$route.params.search;
        LifeStyleApi.getSearchPosts(searchValue, self.getPostParams)
          .then((response) => {
            self.loadingMore = false;
            if  (response.data.posts.length === 0) {
              self.loadMore = false;
            }
            self.posts.push.apply(self.posts, response.data.posts);
            self.filterResults();
          });
      },
      filterResults(value) {
        let self = this;
        self.$nextTick(function () {
          if (self.sortBy === 1) {
            let mostFavourites = _.orderBy(self.posts, (item) => {
              return item.post_favourites;
            }, ['desc']);
            self.posts = mostFavourites;
          }

          if (self.sortBy === 2) {
            let newestResults = _.orderBy(self.posts, (item) => {
              return moment(item.post_date).format('YYYYMMDD');
            }, ['desc']);
            self.posts = newestResults;
          }
          self.$forceUpdate();
        })
      },
      handlePageChange(page) {
        let self = this;
        self.isLoading = true;
        self.getPostParams.page = page;
        self.loadPosts();
      },
      moment(date) {
        return moment(date);
      },
      loadPosts() {
        let self = this;
        let searchValue = self.$route.params.search;
        LifeStyleApi.getSearchPosts(searchValue, self.getPostParams)
          .then((response) => {
            self.isLoading = false;
            self.posts = response.data.posts;
            self.total_pages = response.data.total_pages;
            self.filterResults();
          });
      },
      setTitle(title) {
        TitleManager.setTitle(title);
      },
      favouritePost(post_id) {
        let self = this,
          post = _.find(self.posts, ['post_id', post_id]);
        LifeStyleApi.favouritePost({
          post_id: post_id
        }).then((res) => {
          const callback = res.data;
          if (callback.fav_status) {
            post.post_favourited = true;
            post.post_favourites += 1;
          } else {
            post.post_favourited = false;
            post.post_favourites -= 1;
          }
        });
      },
      goTo(slug) {
        let self = this;
        self.$router.push({name: 'LifeStyleArticle', params: {permalink: slug}})
      },
      initMounted() {
        let self = this, el = self.$route.meta.id;
        self.posts = [];
        self.isLoading = true;
        self.isPostsFinished = false;
        self.isAppending = false;
        self.loadMore = true;
        self.loadPosts();
      }
    },
    computed: {
      chunkedItems () {
        let self = this;
        return _.chunk(_.toArray(self.posts), 3);
      },
      userId() {
        let self = this;
        if (_.has(self.$store.state.user, 'scope')) {
          return self.$store.state.user.scope.user_id;
        }
        return false;
      },
    },
    mounted () {
      let self = this;
      self.initMounted();
    },
  }
</script>
<style lang="less">
  @import "./LifeSearch.less";
</style>



// WEBPACK FOOTER //
// LifeSearch.vue?7dcfc14e